/* eslint-disable new-cap */
import BasicSprite from '../BasicSprite';
import Phaser from 'phaser';
import ABCyaPhaser, { Tweens } from '@abcya/abcya_phaser';
import gameData from '../../gameData';

export default class Title {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    let startY = 270;
    if (gameData.config.subTitle) {
      startY = 240;

      this.subTitle = new BasicSprite(this.scene, 300, 390, gameData.config.subTitle).setScale(0);
      this.scene.add.existing(this.subTitle);
    }

    this.topGraphic = new BasicSprite(this.scene, -this.scene.scale.width - 300, 150, 'titleTop', null, null, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.botGraphic = new BasicSprite(this.scene, this.scene.scale.width + 200, startY, 'titleBot', null, null, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.scene.add.existing(this.topGraphic);
    this.scene.add.existing(this.botGraphic);

    this.group = this.scene.add.container();

    this.counter = 0;
    this.step = Math.PI * 2 / 360;

    this.group.add(this.topGraphic);
    this.group.add(this.botGraphic);

    this.AnimateIn();
  }

  AnimateIn() {
    this.scene.events.on('update', () => {this.Update();});

    let topX = -50 + this.scene.scale.width * .5;
    let botX = 100 + this.scene.scale.width * .5;
    if (!gameData.config.showOption) {
      console.log(gameData.config);
      topX = -100 + this.scene.scale.width * .5;
      botX = 175 + this.scene.scale.width * .5;

      if (this.subTitle) Tweens.addTween(this.subTitle, 1000, { delay: 500, scale: 1 }, Phaser.Math.Easing.Back.Out);
    }

    Tweens.addTween(this.botGraphic, 1000, { x: botX }, Phaser.Math.Easing.Back.Out);
    Tweens.addTween(this.topGraphic, 1000, { x: topX }, Phaser.Math.Easing.Back.Out);
  }

  AnimateOut() {
    Tweens.addTween(this.botGraphic, 1200, { x: this.scene.scale.width * .5 + 800 }, Phaser.Math.Easing.Back);
    Tweens.addTween(this.topGraphic, 2000, { x: -this.scene.scale.width * .5 - 600 }, Phaser.Math.Easing.Back);
  }

  Update() {
    const tStep = Math.sin(this.counter);
    this.group.y = tStep * 10;
    this.group.angle += 0.02 * tStep;
    this.counter += this.step;
  }
}


